import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GpsLogsResponse } from './gps-logs-response.model';

export enum RequestType { Site = 1, Council = 2 }

@Injectable()
export class GpsLogsService {
    constructor(private http: HttpClient) {
    }

    get(requestType: RequestType, filter: string, latitude: number, longitude: number): Observable<GpsLogsResponse> {
        return this.http.get<GpsLogsResponse>('gps-logs', {
            params: new HttpParams()
                .set('latitude', latitude.toString())
                .set('longitude', longitude.toString())
                .set('filter', filter)
                .set('requestType', requestType.toString())
        });
    }
}
